import React from "react";
import {
  Button,
  PageHeader,
  Row,
  Tag,
  Typography,
  List,
  Modal,
  Tooltip,
  Badge,
  Popover,
  Alert,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PauseCircleOutlined,
  PlayCircleOutlined,
  ClockCircleOutlined,
  FileSearchOutlined,
  InfoCircleOutlined,
  ExportOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  FieldTimeOutlined,
  SendOutlined,
  SyncOutlined,
  IdcardOutlined,
  GiftOutlined,
  TruckFilled,
} from "@ant-design/icons";
import moment from "moment";
import logo from "../../assets/images/logo.png";
import Marquee from "react-fast-marquee";

import {
  APP_ENV
} from "./../../services";

const { Paragraph, Title } = Typography;



const RETURN_LABEL_CHECK = [
  "Return in person",
  "Create return Label",
  "Return In Transit",
  "Return Received",
];


  const getStatusTag = (status = "pending") => {
    const current = statusMap[status] || statusMap["pending"];
    return (
      <Tag  color={current.color} style={{ fontSize: 13, padding: "2px 6px",border: '0' }}>
        {current.label}
      </Tag>
    );
  };

const statusMap = {
    pre_transit: { color: "gold", label: "Label Created 🏷️" },
    in_transit: { color: "blue", label: "In Transit 🚚" },
    out_for_delivery: { color: "purple", label: "Out for Delivery 📦" },
    delivered: { color: "green", label: "Delivered ✅" },
    pending: { color: "orange", label: "Pending ⏳" },
    pending_shipment: { color: "orange", label: "Pending ⏳"}
  };
// const RETURN_LABEL_CHECK = ["Received","In Transit"];

const Content = ({ children, extraContent }) => (
  <Row>
    <div className="image">{extraContent}</div>
    <div
      style={{
        flex: 2,
      }}
    >
      {children}
    </div>
  </Row>
);

const MyParagraphView = ({ data }) => {
  return (
    <Paragraph>
      {Object.entries(data).map(([key, value]) => (
        <span key={key}>
          <strong>{`${key}: `}</strong>
          {value}
          <br />
        </span>
      ))}
    </Paragraph>
  );
};

const getData = (myData, keysToInclude) => {
  const filteredData = Object.fromEntries(
    Object.entries(myData).filter(([key]) => keysToInclude.includes(key))
  );

  // Convert filtered data to the desired format
  const transformedData = Object.entries(filteredData).map(([key, value]) => ({
    label: key,
    value: value,
  }));

  return transformedData;
};

// const objEmpty = async (test) => {
//   return test && typeof test === "object" && Object.keys(test).length > 0;
// };

const objEmpty = (test) => {
  return test && typeof test === "object" && !Array.isArray(test) && Object.keys(test).length > 0;
}

const StripePlans = (props) => {
  const {
    subscription,
    shipstation_response,
    amount_total,
    coupon_id,
    payment_response,subscription_response,
    sub_simulation_date,
    shipment_status
  } = props;



  const { plan, trial_start, trial_end,current_period_end,status,pause_collection,metadata } =  (props.status==="canceled")   ?  payment_response : subscription;

  console.log(metadata,plan, trial_start, trial_end,current_period_end,status);

  const planStatus = status=="trialing" ? true : false;
  
// const currentTime = Math.floor(Date.now() / 1000);
 const currentTime = parseInt(sub_simulation_date);
 let daysLeft = 0;

 


 if(APP_ENV==="DEVELOPMENT"){

  if (currentTime < current_period_end) {
     daysLeft = Math.ceil((current_period_end - currentTime) / 86400);
  } 
}

console.log(pause_collection,objEmpty(pause_collection),daysLeft,props.sensor_shipment_period);

daysLeft = (objEmpty(pause_collection)  ? ( status=="trialing" ? daysLeft :(daysLeft+props.sensor_shipment_period)) : daysLeft  );

console.log(daysLeft);


  const shipstation_tracking =
    shipstation_response && objEmpty(shipstation_response)
      ? shipstation_response.trackingNumber
      : false;

  console.log(subscription); 

  // const endDate = props.sub_expires_at;

  const endDate = moment
        .unix(current_period_end)
        .format("MMMM DD, YYYY");

        

  // const durationInSeconds =
  //   subscription.current_period_end - subscription.current_period_start;
  // const durationInDays = moment.duration(durationInSeconds, "seconds").asDays();

  // console.log(startDate, endDate, durationInDays);

  const subscription_info = (
    <div>
      <div>
        You may continue using the Aletheia sensor until the end of the current
        subscription period.
      </div>
      <div>
        Please return your sensor within 1 week of the end of your subscription
        period to avoid additional charges.
      </div>
      <div>
        <b>Valid until {endDate}</b>
      </div>
    </div>
  );


  console.log(metadata);
  const shippingQty = parseInt(metadata?.qty || 1);


  const shippingQtyValue  = 
  (subscription_response?.pd_total_details?.amount_shipping /
                          100 /shippingQty
).toFixed(2);

console.log(shippingQty);

console.log(shippingQtyValue);


  return (
    // <Badge.Ribbon text="TRIAL PERIOD"  placement={"start"}>
    <PageHeader
      style={{ boxShadow: "0 0 1.5em #ccc", borderRadius: "20px" }}
      title={<Tooltip title={planStatus ? 'Aletheia Run 1 Month Free Trial Membership $0' : plan.nickname}>{planStatus ? 'Aletheia Run 1 Month Free Trial Membership $0' : plan.nickname}</Tooltip>}
      className="site-page-header"
      // tags={
      //   props.status == "active" ? (
      //     <Tag color="green">Active</Tag>
      //   ) : props.status === "canceled" ? (
      //     <Tag color="red">{props.status}</Tag>
      //   ) : (
      //     <Tag color="orange">{props.status}</Tag>
      //   )
      // }
      extra={[
        props.mode === "payment" || props.mode === "subscription" ? (
          <>
            {/* {props.status == "active" ? (
              <Tooltip title="Pause Subscription">
                {" "}
                <Button
                  key="4"
                  shape="round"
                  size="small"
                  icon={<PauseCircleOutlined />}
                  onClick={() => props.unSubscribe(props, "pause")}
                />{" "}
              </Tooltip>
            ) : props.status == "paused" ? (
              <Tooltip title="Resume Subscription">
                {" "}
                <Button
                  key="2"
                  shape="round"
                  size="small"
                  icon={<PlayCircleOutlined />}
                  onClick={() => props.unSubscribe(props, "resume")}
                />
              </Tooltip>
            ) : (
              " "
            )} */}
 
            <Tooltip title="View Subscription">
              <Button
                key="3"
                shape="round"
                size="small"
                icon={<InfoCircleOutlined />}
                onClick={() => props.updateSub("order", props)}
              />
            </Tooltip>

            {
            props.status !== "canceled" 
            // && props.status !== "paused"
            ? (
              <Tooltip title="Cancel Subscription">
               
                <Button
                  key="1"
                  shape="round"
                  type="danger"
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => props.unSubscribe(props, "canceled")}
                />
              </Tooltip>
            ) : (
              ""
            )}
          </>
        ) : (
          " "
        ),
      ]}
      avatar={{
        src: logo,
      }}
      breadcrumb={[
        {
          path: "index",
          breadcrumbName: "First-level Menu",
        },
        {
          path: "first",
          breadcrumbName: "Second-level Menu",
        },
      ]}
    >
      <Content>
        {/* <List
          size="small"
          dataSource={getData(props, [
            
            "amount_total",
            // "currency",
            // "stripe_subscription_id",
            // "customer_id",
            "payment_status"
            
          ])}
          renderItem={(item) => (
            <List.Item>
              <Typography.Text>
                <b>{item.label}</b>
              </Typography.Text>
              : {item.value}
            </List.Item>
          )}
        /> */}

        <List size="small">
          <List.Item>
            <Typography.Text>
              <b>Amount</b> 
            </Typography.Text>
            :
            <div>
              {planStatus ? <Title>
                {" "}
                $0
                <span
                  className="plan_dur"
                >
                  / Month
                  <>
                     {subscription_response?.pd_total_details?.amount_shipping > 0 ? (
                       <span style={{ color: "#1890ff", fontSize: "15px" }}>
                        (+$
                        {shippingQtyValue}
                        {subscription_response?.pd_total_details?.amount_shipping===100 ? ' Pick Up' : ' Shipping'})
                      </span>
                    ) : (
                      " "
                    )}{" "}
                  </>
                  &nbsp;{" "}
                  {coupon_id !== null ? (
                    <span style={{ color: "#ff9800" }}>
                      (${plan?.amount / 100} <GiftOutlined /> )
                    </span>
                  ) : (
                    ""
                  )}{" "}
                </span>
              </Title> 
             : <Title>
                {" "}
                ${ plan?.amount /100}
                <span
                  className="plan_dur"
                >
                  / {plan?.interval}{" "}
                  <>
                    {subscription_response?.pd_total_details?.amount_shipping > 0 ? (
                      <span style={{ color: "#1890ff", fontSize: "15px" }}>
                        (+$
                        {shippingQtyValue}
                       {subscription_response?.pd_total_details?.amount_shipping===100 ? ' Pick Up' : ' Shipping'} )
                      </span>
                    ) : (
                      " "
                    )}{" "}
                  </>
                  &nbsp;{" "}
                  {coupon_id !== null ? (
                    <span style={{ color: "#ff9800" }}>
                      (${plan?.amount / 100} <GiftOutlined /> )
                    </span>
                  ) : (
                    ""
                  )}{" "}
                </span>
              </Title>}
            </div>
          </List.Item>

         <List.Item
              onClick={() => props.updateSub("order", props)}
              style={{ cursor: "pointer" }}
            >
              <Typography.Text>
                <b>
                  <TruckFilled /> Shipment  {getStatusTag(shipment_status)}
                </b>
              </Typography.Text>
             
              
            </List.Item>

          <List.Item>
            <Typography.Text>
              <b>
                {" "}
                <ClockCircleOutlined />{" "}
                {props.status === "canceled"
                  ? "Valid until"
                  : "Subscription renews"}{" "}
              </b>
            </Typography.Text>
            : <Tag color="default">{endDate}</Tag>
          </List.Item>

          <List.Item>
            <Typography.Text>
              <b>
                {" "}
                <InfoCircleOutlined /> Status
              </b>
            </Typography.Text>
            :{" "}
            <b>
              {props.status === "active" ? (
                <Tag icon={<CheckCircleOutlined />} color="green">
                  Active
                </Tag>
              ) : props.status === "canceled" ? (
                <Tag icon={<CloseCircleOutlined />} color="red">
                  <Popover
                    content={subscription_info}
                    title="Subscription Status"
                  >
                    <b>{props.status}</b>
                  </Popover>
                </Tag>
              ) : props.status === "expired" ? (
                <>
                  <Tag icon={<CloseCircleOutlined />} color="#ccc">
                    Expired
                  </Tag>{" "}
                  &nbsp;
                  {props.index === 0 ? (
                    <Tag
                      onClick={() => props.updateSub("subscription", {})}
                      style={{
                        fontSize: "15px",
                        cursor: "pointer",
                        padding: "2px 13px",
                      }}
                      className="new_pd_sub"
                      icon={
                        <>
                          <SyncOutlined spin />{" "}
                          <Badge status="processing" color="green" text="" />
                        </>
                      }
                      color="green"
                    >
                      Renew Subscription
                    </Tag>
                  ) : (
                    ""
                  )}{" "}
                </>
              ) : props.status === "grace_period" ? (
                <>
                  <Tag
                    icon={<FieldTimeOutlined style={{ fontSize: "18px" }} />}
                    color="default"
                  >
                    <Badge status="processing" color="red" text="" /> Grace
                    Period
                  </Tag>
                  &nbsp;
                  {props.index === 0 ? (
                    <Tag
                      onClick={() => props.updateSub("subscription", {})}
                      style={{
                        fontSize: "15px",
                        cursor: "pointer",
                        padding: "2px 13px",
                      }}
                      className="new_pd_sub"
                      icon={
                        <>
                          <SyncOutlined spin />{" "}
                          <Badge status="processing" color="green" text="" />
                        </>
                      }
                      color="green"
                    >
                      Renew Subscription
                    </Tag>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                <Tag icon={<InfoCircleOutlined />} color="processing">
                  {props.status} 
                </Tag>
              )}
            </b>

           
          {planStatus ?   <Tag icon={<ClockCircleOutlined />} color="cyan">Trial Period</Tag> : ''} 
               
          </List.Item>

          {RETURN_LABEL_CHECK.indexOf(props.order_status) === -1 &&
          ["active", "paused"].indexOf(props.status) === -1 &&
          props.sensor_return_period <= 7 ? (
            <List.Item>
              <Typography.Text>
                <b >
                  
                  <InfoCircleOutlined /> Sensor Return Period
                </b>
                <b>
                  {" "}
                  &nbsp;
                  {props.sensor_return_period === 0 ? (
                    <Tag icon={<CloseCircleOutlined />} color="red">
                      Failure to Return
                    </Tag>
                  ) : (
                    <Tag icon={<CheckCircleOutlined />} color="green">
                      {props.sensor_return_period}{" "}
                      {props.sensor_return_period === 1 ? "Day" : "Days"} Left
                    </Tag>
                  )}
                </b>{" "}
              </Typography.Text>
            </List.Item>
          ) : (
            ""
          )}

 




          {RETURN_LABEL_CHECK.indexOf(props.order_status) !== -1 ? (
            <List.Item>
              <Typography.Text>
                {props.order_status === "Create return Label" ? (
                  <>
                    <b>
                      {" "}
                      <InfoCircleOutlined />
                      {props.order_status}
                    </b>
                    <b>
                      {" "}
                      &nbsp;
                      <Tag icon={<CheckCircleOutlined />} color="success">
                        Paid $8.97 (USD)
                      </Tag>{" "}
                    </b>{" "}
                  </>
                ) : (
                  <>
                    <b>
                      {" "}
                      <InfoCircleOutlined /> {props.order_status}
                    </b>
                    <b>
                      {" "}
                      &nbsp;
                      <Tag icon={<CheckCircleOutlined />} color="success">
                        Initiated
                      </Tag>
                    </b>{" "}
                  </>
                )}
              </Typography.Text>
            </List.Item>
          ) : (
            ""
          )}


{APP_ENV==="DEVELOPMENT" ?
            <List.Item>
              <Typography.Text>
                <b style={{color:'orange'}}>
                  {" "}
                  <ClockCircleOutlined   /> Time simulation
                </b> &nbsp;
                <b>
                &nbsp;
                <Tag color="purple">{moment
        .unix(currentTime)
        .format("MMMM DD, YYYY")}</Tag> : &nbsp; <Tag color="orange">{ (planStatus===false && metadata.activation==="false" ? 365 : daysLeft)}  {daysLeft===1 ? 'Day':'Days'} remaining</Tag>
                </b>
              </Typography.Text>

             
            </List.Item>
          : ""}


{/* 
{APP_ENV==="DEVELOPMENT" ?
            <List.Item>
              <Typography.Text>
                <b style={{color:'purple'}}>
                  {" "}
                  <ClockCircleOutlined   /> Sensor Activition
                </b> &nbsp;
                <b>
                &nbsp;
                <Tag color="purple"> {props.sensor_return_period}</Tag>
                
                </b>
              </Typography.Text>
              <Typography.Text>
                <b style={{color:'orange'}}>
                  {" "}
                  <ClockCircleOutlined   /> sensor_shipment_period
                </b> &nbsp;
                <b>
                &nbsp;
                <Tag color="purple">{props.sensor_shipment_period}</Tag> 
                </b>
              </Typography.Text>
              
            </List.Item>
          : ""}

{APP_ENV==="DEVELOPMENT" ?
            <List.Item>
              <Typography.Text>
                <b style={{color:'purple'}}>
                  {" "}
                  <ClockCircleOutlined   /> sub_canceled_at
                </b> &nbsp;
                <b>
                &nbsp;
                <Tag color="purple">{moment
        .unix(props.sub_canceled_at)
        .format("MMMM DD, YYYY")} </Tag>
                
                </b>
              </Typography.Text>
            </List.Item>
          : ""}
          
          {APP_ENV==="DEVELOPMENT" ?
            <List.Item>
              <Typography.Text>
                <b style={{color:'purple'}}>
                  {" "}
                  <ClockCircleOutlined   /> sub_activation_days
                </b> &nbsp;
                <b>
                &nbsp;
                <Tag color="purple"> {props.sub_activation_days}</Tag>
                
                </b>
              </Typography.Text>
            </List.Item>
          : ""}

{APP_ENV==="DEVELOPMENT" ?
            <List.Item>
              <Typography.Text>
                <b style={{color:'purple'}}>
                  {" "}
                  <ClockCircleOutlined   /> sub_expires_at
                </b> &nbsp;
                <b>
                &nbsp;
                <Tag color="purple"> {props.sub_expires_at}</Tag>
                
                </b>
              </Typography.Text>
            </List.Item>
          : ""} */}

          
        </List>

        

        {/* {RETURN_LABEL_CHECK.indexOf(props.order_status) == -1 &&
        ["active", "paused"].indexOf(props.status) == -1 &&
        props.sensor_return_period <= 7 ? (
          <Alert
            style={{ borderRadius: "10px", boxShadow: "0 0 1em #d0cece" }}
            className="plans_alert_width"
            banner
            message={
              <Marquee pauseOnHover gradient={false}>
                <b>
                 

                  
                {  props.sensor_shipment_period <= 30 ?  ( planStatus  ? 'If Aletheia Sensor is not returned within 7 days you will be charged $239.' : 'To receive your refund the Aletheia Sensor must be returned within 30 days. ') : 'If the sensor is not returned within 1 week, a $80 fee will be charged.'}
                  
                </b>
              </Marquee>
            }
          />
        ) : (
          " "
        )} */}
        {/* {Object.keys(shipping_info).length ? <MyParagraphView data={shipping_info.address} /> : " "} 
        <div>
     
      <IconLink
        src="https://gw.alipayobjects.com/zos/rmsportal/ohOEPSYdDTNnyMbGuyLb.svg"
        text=" Invoice Details"
      />
    </div>*/}
      </Content>
    </PageHeader>
    // </Badge.Ribbon>
  );
};
export default StripePlans;
